<template>
    <div>
        <div v-for="(item, index) in defaultQuestion" :key="'table1' + index">
            <el-table :data="item.value" style="width: 100%;margin-top: 15px;margin-bottom: 35px;" :dimensionName="item.name">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <div class="props-div">
                            <el-checkbox-group v-model="props.row.checkList">
                                <el-checkbox v-for="(ite, ind) in props.row.value" :key="'check' + ind" :label="ite.id"
                                    disabled>
                                    <div class="p-d-item">
                                        <p class="p-d-i-p">{{ ite.fourthIndicatorName }} <span class="p-d-i-s">{{
                                            ite.classify }}</span></p>
                                    </div>
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="item.name" prop="name">
                </el-table-column>
                <el-table-column label="进度" prop="total">
                    <template slot-scope="scope">
                        <div class="table-progress">
                            <div class="table-progress-item">
                                <el-progress :percentage="(scope.row.progress / scope.row.total) * 100"
                                    :show-text="false"></el-progress>
                            </div>
                            <span class="table-progress-span">{{ scope.row.progress + '/' + scope.row.total
                            }}</span>
                        </div>

                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="name">
                    <template slot-scope="scope">
                        <span>{{ scope.row.status | statusFilter }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" prop="desc">
                    <template slot-scope="scope">
                        <div>
                            <el-button style="margin-left: 0px;"
                                @click="toViewQuestions(scope.row.name, 1, item.value.length, scope.$index + 1, item.name)">查看</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'IndexQuestions',
    props: {
        questionsList: Array,
        infoId: Number
    },
    data() {
        return {
            defaultQuestion: [],//按指标分类
        }
    },
    watch: {
        questionsList(news) {
            this.defaultQuestion = news
        }
    },
    mounted() {
       
    },
    filters: {
        statusFilter(val) {
            switch (val) {
                case 1:
                    return '未编辑'
                case 2:
                    return '编辑中'
                case 3:
                    return '待提交'
                case 4:
                    return '已提交'
            }
        }
    },
    methods: {
        //去答题页面
        toTest(name, type, qusLength, qusIndex, dName) {
            // console.log(name, type, qusLength, qusIndex);
            const subName = dName.substr(0,2)
            this.$router.push({
                name: 'TestPage',
                query: {
                    infoId: this.infoId,
                    name,
                    type,
                    qusLength,
                    qusIndex,
                    dimensionName: subName
                }
            });
        },
        //去查看题目页面
        toViewQuestions(name, type, qusLength, qusIndex, dName) {
            const subName = dName.substr(0,2)
            this.$router.push({
                name: 'ViewQuestionsDetail',
                query: {
                    infoId: this.infoId,
                    name,
                    type,
                    qusLength,
                    qusIndex,
                    dimensionName: subName
                }
            });
        },
        updateData() {
            this.$emit('dataUpdated')
        },
        //分配部门
        distribution(arr) {
            this.$emit('distribution', arr)
        },
        allCheck(val, index, ind) {
            this.$emit('allCheck1', val, index, ind)
        }
    }
}
</script>
<style lang="scss" scoped>
.props-div {
    // height: 200px;
    // background-color: red;
    padding-left: 20px;

    .el-checkbox-group {
        .el-checkbox {
            display: block;
            position: relative;
            margin: 5px 0;

            .p-d-item {
                .p-d-i-p {
                    .p-d-i-s {
                        position: absolute;
                        right: 5%;
                        top: center;
                        color: #3B9395;
                        width: 100px;
                    }
                }
            }
        }
    }
}

.table-progress {
    .table-progress-item {
        width: calc(100% - 62px);
        display: inline-block;
    }

    .table-progress-span {
        width: 50px;
        margin-left: 10px;
        display: inline-block;
    }
}
</style>